import React, { useEffect, useState, lazy, Suspense } from "react";

const ParkingSlotRow = lazy(() => import("../ParkingSlotRow"));

export default function MainCalendar({
  unitWidth,
  driver,
  numberOfUnits,
  parkingSlots,
  sortedDataset,
}) {
  return (
    <>
      <div className={"main-calendar"}>
        {parkingSlots?.map((parkingSlot) => (
          <Suspense
            fallback={<div className="w-100 d-flex"></div>}
            key={parkingSlot.id}
          >
            <ParkingSlotRow
              unitWidth={unitWidth}
              driver={driver}
              numberOfUnits={numberOfUnits}
              slotName={
                "name" in parkingSlot ? parkingSlot.name : parkingSlot.id
              }
              category={parkingSlot.category}
              slotData={
                parkingSlot.id in sortedDataset
                  ? sortedDataset[parkingSlot.id]
                  : []
              }
              key={parkingSlot.id}
            />
          </Suspense>
        ))}
      </div>
    </>
  );
}
